/**
 * @generated SignedSource<<bd3a5b54f24940b458ceeca279b64d55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlightsRowActions_package$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_package">;
  readonly " $fragmentType": "PackageEditTransportFlightsRowActions_package";
};
export type PackageEditTransportFlightsRowActions_package$key = {
  readonly " $data"?: PackageEditTransportFlightsRowActions_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRowActions_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlightsRowActions_package",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_package"
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "0ce3712313a0bf1ce78153d754fc7e5d";

export default node;
